import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@nxt/shared-auth';
//import { DeactivateGuardService } from 'libs/shared-lib1/src/lib/shared/services/deactivate-guard.service';
import { App1WrapperComponent } from './app1Wrapper.component';
import { App1ErrorHandleComponent } from './components/app1-error-handle/app1-error-handle.component';
import { App1HomeComponent } from './components/app1-home/app1-home.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { TestTranslateComponent } from './components/test-translate/test-translate.component';
import { Test9MovieListComponent } from './components/test9-movie-list/test9-movie-list.component';
import { App1MainResolverResolver } from './services/resolvers/app1-main-resolver.resolver';
//import { CanDeactivateGuard } from 'libs/shared-lib1/src/lib/shared/services/can-deactivate.guard';
import { ConfirmationGuard } from 'libs/shared-lib1/src/lib/shared/guards/confirmation.guard';

const routes: Routes = [

  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },

  // { path: 'index.html', redirectTo: '/auth2', pathMatch: 'full' },

  {
    path: 'home',
    component: App1HomeComponent,
    //resolve: { resolvedDataForApp1: App1MainResolverResolver },
    //canActivate: [AuthGuard],    
    //canDeactivate: [ConfirmationGuard]
  },

  {
    path: 'test-translate',
    component: TestTranslateComponent,
    //outlet: 'app1Router',
    //canDeactivate: [ConfirmationGuard]
  },

  {
    path: 'test-error-handle',
    component: App1ErrorHandleComponent,
    //outlet: 'app1Router',
    //canDeactivate: [ConfirmationGuard]
  },

  {
    path: 'ngrx',
    component: Test9MovieListComponent,
  },

  {
    path: 'auth',
    loadChildren: () => import('@nxt/shared-auth').then(m => m.SharedAuthModule)
  },

  {
    path: 'test-stuff',
    //canActivate: [AuthGuard],
    //canActivateChild: [AuthGuard],
    loadChildren: () => import('./modules/testing-stuff/testing-stuff.module').then(m => m.TestingStuffModule)

  },

  { path: '**', component: PageNotFoundComponent }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class App1RoutingModule { }
